// Vendors
import { sessionUtils } from '@openbank/cf-ui-architecture-core';
// Utils
import { getAppDomain } from 'utils/domain.utils';

const IFRAME_WS_CONFIGURATION = {
    refreshToken: async () => sessionUtils.refreshToken({ isGil: true, domain: getAppDomain() }),
  },
  IFRAME_WS_MESSAGE_PROPS = {
    eventType: '$default',
    service: 'gil-api-mng-amz-ldg',
  },
  IFRAME_WS_LIMIT_CONFIGURATION = {
    limitTime: 300, // Seconds
  };

export { IFRAME_WS_CONFIGURATION, IFRAME_WS_MESSAGE_PROPS, IFRAME_WS_LIMIT_CONFIGURATION };
